import React, { useState } from 'react';
import { X, Send, Loader, MessageSquare } from 'lucide-react';
import { config } from '../../config';
import { syncManager } from '../../services/sync';

const BroadcastModal = ({ onClose }) => {
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        targetRole: 'CLIENT',
        message: '',
        includeAttachments: false
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await syncManager.triggerWorkflow('hq-broadcast', formData);
            alert('Broadcast started!');
            onClose();
        } catch (error) {
            alert('Error: ' + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="bg-slate-50 border-b border-slate-100 p-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-100 p-2 rounded-xl text-blue-600">
                            <MessageSquare size={20} />
                        </div>
                        <h2 className="text-xl font-black text-slate-800">Broadcast WhatsApp</h2>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Target Audience</label>
                            <select value={formData.targetRole} onChange={e => setFormData({ ...formData, targetRole: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option value="CLIENT">All Active Clients</option>
                                <option value="CUSTOMER">Service Customers</option>
                                <option value="LEAD">Leads Only</option>
                                <option value="ALL">Everyone</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Message Body</label>
                            <textarea
                                required
                                rows={5}
                                value={formData.message}
                                onChange={e => setFormData({ ...formData, message: e.target.value })}
                                className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl resize-none"
                                placeholder="Write your broadcast message here..."
                            />
                        </div>
                        <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest flex items-center justify-center gap-2">
                            {submitting ? <Loader className="animate-spin" /> : <><Send size={20} /> Send Broadcast</>}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BroadcastModal;
